<template>
  <teleport to="body">
    <div v-if="visible === true" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="bg-base-100 dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-lg mx-4" :dir="isRtl === true ? 'rtl' : 'ltr'">
        <h3 class="text-lg font-semibold mb-1">{{ t('agentCreate.knowledge.websiteModal.title', 'Upload entire website') }}</h3>
        <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">{{ t('agentCreate.knowledge.websiteModal.hint', 'Enter the main website URL. We will crawl and index its pages.') }}</p>
        <input
          v-model="websiteUrl"
          type="text"
          class="input input-bordered w-full"
          :placeholder="t('agentCreate.knowledge.websiteModal.placeholder', 'https://example.com')"
        />
        <div class="flex justify-end mt-6">
          <button type="button" class="btn" @click="onClose">{{ t('common.cancel', 'Cancel') }}</button>
          <button type="button" class="btn ml-2" :disabled="canConfirm === false" @click="onConfirm">{{ t('common.confirm', 'Confirm') }}</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useI18n } from '@/i18n';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close', 'confirm']);

const { t, currentLanguage, availableLanguages } = useI18n();
const websiteUrl = ref('');

const isRtl = computed(() => {
  const language = availableLanguages.value.find((item) => item.code === currentLanguage.value);
  if (language === undefined || language === null) {
    return false;
  }
  return language.dir === 'rtl';
});

const canConfirm = computed(() => {
  return typeof websiteUrl.value === 'string' && websiteUrl.value.trim().length > 3;
});

watch(() => props.visible, (value) => {
  if (value === true) {
    websiteUrl.value = '';
  }
});

function onClose() {
  emit('close');
}

function onConfirm() {
  if (canConfirm.value === false) {
    return;
  }
  emit('confirm', websiteUrl.value.trim());
}
</script>
